import React from 'react';
import cc from 'classcat';
import './spriteIcon.css';

interface SpriteIconProps {
  /**
   Link for sprite image
   */
  src: string;
  /**
   Picture number value (1-30)
   */
  value: string;
  /**
   Image variation to be used in LiveBalls once is called
   */
  active?: boolean;
  /**
   Image variation to be used in GameBoard before ticket is bought or when the number is not called yet
   */
  disabled?: boolean;
}

/**
 * Displays an image mapped from a sprite, which can be used to display picture balls in bingo 30
 *
 * @example [Tutorial to generate the sprite image](https://www.notion.so/mrqcom/Generate-sprite-image-15dcf39a48f540df8d2ca8728a68d906)
 * */
const SpriteIcon = ({ src, value, active = false, disabled = false }: SpriteIconProps) => (
  <div
    className={cc([
      'spriteIcon',
      value && `spriteIcon--${value}-default`,
      active && `spriteIcon--${value}-active`,
      disabled && `spriteIcon--${value}-grey`
    ])}
    style={{ '--spriteUrl': `url('${src}')` }}
  />
);

export default SpriteIcon;
